import { useState } from "react";

export function useProductSelection() {
  const [selectedProducts, setSelectedProducts] = useState([]);

  const handleSelectAll = (checked, filteredProducts) => {
    if (checked) {
      setSelectedProducts(filteredProducts.map((p) => p.id));
    } else {
      setSelectedProducts([]);
    }
  };

  const handleSelectProduct = (id, checked) => {
    if (checked) {
      setSelectedProducts([...selectedProducts, id]);
    } else {
      setSelectedProducts(selectedProducts.filter((pId) => pId !== id));
    }
  };

  const clearSelection = () => {
    setSelectedProducts([]);
  };

  return {
    selectedProducts,
    handleSelectAll,
    handleSelectProduct,
    clearSelection,
  };
}
